import { render, staticRenderFns } from "./QueryOverview.vue?vue&type=template&id=4bebb8d7&scoped=true"
import script from "./QueryOverview.vue?vue&type=script&lang=ts"
export * from "./QueryOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bebb8d7",
  null
  
)

export default component.exports